import axios from "axios";

export default {
  state: {
    appItems: [],
    currentItem: {
      name: "Covid",
      description: `Лукашенко впервые ведет войну на трех войнах», — порассуждал политолог Александр Федута, являвшийся в 1994 году членом предвыбороного штаба Лукашенко. По его мнению, белорусский лидер пытается запугать граждан, чтобы они не выходили на митинги. Аналитики отмечают, что на фоне массовых протестов и напряженности в отношениях с Россией из-за вопроса экономической интеграции двух стран, власти Белоруссии обвинили 33 россиян в планах дестабилизировать обстановку в стране в преддверии выборов. Эксперты отмечают, что Лукашенко, вероятно, отпустит задержанных после выборов, однако сейчас он хочет убедить общественность в исходящей опасности со стороны Москвы.

Группу из 32 человек задержали в санатории под Минском 29 июля. Еще один человек был задержан на юге страны. По данным белорусских спецслужб, российские наемники прибыли для дестабилизации ситуации в преддверии президентских выборов. Всего в республику якобы въехали 200 бойцов ЧВК.`,
      screens: [
        "https://file.ilook.su/public/AppInfo/Calc/screens/screen_en_1.png",
        "https://file.ilook.su/public/AppInfo/Calc/screens/screen_en_2.png",
        "https://file.ilook.su/public/AppInfo/Calc/screens/screen_en_3.png",
        "https://file.ilook.su/public/AppInfo/Calc/screens/screen_en_4.png",
        "https://file.ilook.su/public/AppInfo/Calc/screens/screen_en_1.png",
        "https://file.ilook.su/public/AppInfo/Calc/screens/screen_en_2.png",
        "https://file.ilook.su/public/AppInfo/Calc/screens/screen_en_3.png",
        "https://file.ilook.su/public/AppInfo/Calc/screens/screen_en_4.png",
      ],
    },
  },
  getters: {
    getAppTitles(state) {
      return state.appItems.map((item) => {
        return item.title;
      });
    },
    getCurrentItem(state) {
      return state.currentItem;
    },
    getAppItems(state) {
      return state.appItems;
    },
  },
  mutations: {
    updateCurrent(state, payload) {
      state.currentItem = payload;
    },
    updateAppList(state, payload) {
      state.appItems = payload;
    },
  },
  actions: {
    updateCurrentAction({ commit }, payload) {
      let config = {
        headers: {
          lang: payload.lang,
        },
      };

      axios
        .get(`https://file.ilook.su/AppInfo/api/info/${payload.name}`, config)
        .then((response) => response.data)
        .then((data) => {
          console.log(data);
          if (data && data.result) {
            commit("updateCurrent", data.result);
          }
        })
        .catch((error) => console.log(error));
    },
    updateAppsAction({ commit }, payload) {
      let config = {
        headers: {
          lang: payload.lang,
        },
      };

      axios
        .get("https://file.ilook.su/AppInfo/api/info/", config)
        .then((response) => response.data)
        .then((data) => {
          console.log(data);
          if (data && data.result) {
            commit("updateAppList", data.result);
          }
        })
        .catch((error) => console.log(error));
    },
  },
};
